export interface CompetenciesRouter {
  goToList(query?: string): void;
  goToDetail(id: string): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompetenciesRouter = Symbol('CompetenciesRouter');
